/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-09-16 14:54:38
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-10-09 15:34:15
 */

import store from '../../../store'
import i18n from '../../i18n/i18n'
import Vue from 'vue'

export default function () {
  return new Promise((resolve) => {
    Vue.prototype.$bridge.registerHandler('AppCallH5', (data, responseCallback) => {
      // console.log('app传递参数', data)
      if (!data || data === undefined) {
        // console.log('data', data)
        console.log('当前不再APP环境')
        return
      }
      // console.log(JSON.parse(data))
      if (JSON.parse(data).langType) {
        i18n.locale = JSON.parse(data).langType
        localStorage.setItem('lang', JSON.parse(data).langType)
        store.commit('updateLangType', JSON.parse(data).langType)
      } else {
        store.commit('updateLangType', 'cn')
      }
      // console.log(JSON.parse(data))
      if (JSON.parse(data).token) {
        store.commit('updateToken', JSON.parse(data).token)
      } else {
        store.commit('updateToken', '')
      }

      if (JSON.parse(data).stationCode) {
        store.commit('updateStationCode', JSON.parse(data).stationCode)
      } else {
        store.commit('updateStationCode', '')
      }

      if (JSON.parse(data).system) {
        store.commit('updateSystem', JSON.parse(data).system)
      } else {
        store.commit('updateSystem', '')
      }

      if (JSON.parse(data).consultativeCode) {
        store.commit('updateConsultativeCode', JSON.parse(data).consultativeCode)
      } else {
        store.commit('updateConsultativeCode', '')
      }
      resolve()
    })
  })
}



// WEBPACK FOOTER //
// ./src/common/http/appCall.js